<div class="container mt-4 border p-4">
  <!-- Header Section -->
  <div class="d-flex justify-content-between align-items-center mb-4">
    <h5 class="text-muted">{{ 'socialAccount.manageConnectedAccounts' | transloco }}</h5>
    <ng-container>
      @if (!facebookAccountDetail.FaceBookId) {
        <button pButton pRipple type="button"
          (click)="onConnectFacebookAccount()"
          class="p-button p-button-primary p-button-rounded p-button-lg fw-semibold shadow-sm">
          <i class="pi pi-facebook me-2"></i> {{ 'socialAccount.connectFacebook' | transloco }}
        </button>
      }
    </ng-container>
    <!-- <ng-container>
    <button *ngIf="facebookAccountDetail.FaceBookId" pButton pRipple type="button"
      (click)="onDeleteFacebookAccount()"
      class="p-button p-button-primary p-button-rounded p-button-lg fw-semibold shadow-sm">
      <i class="pi pi-facebook me-2"></i> Delete Account
    </button>
  </ng-container> -->
</div>

<!-- Facebook Account Details -->
@if (facebookAccountDetail.FaceBookId) {
  <div class="card p-3 mb-2 shadow border-0">
    <div class="d-flex justify-content-end">
      <!-- Disconnect Button placed at the end, with centered text -->
      <button
        class="p-button-primary p-button-sm p-button-outlined  d-flex justify-content-center align-items-center"
        [style.backgroundColor]="'#f79421'" [style.color]="'white'" [style.border]="'none'"
        (click)="onDisconnectFacebookAccount(facebookAccountDetail.Id)" [pTooltip]="'socialAccount.disconnectFacebook' | transloco"
        tooltipPosition="top">
        <i class="pi pi-times-circle ms-2"></i>
        <span class="ms-3">{{ 'socialAccount.disconnect' | transloco }}</span>
      </button>
    </div>
    <div class="d-flex  align-items-center mb-3">
      <!-- Profile Picture and Disconnect Button -->
      <div class="d-flex align-items-center">
        <img [src]="facebookAccountDetail.FacebookProfilePicture || 'assets/images/No-Image.png'"
          class="rounded-circle shadow-lg me-3" width="150" height="150" />
          <div>
            <!-- Account Details -->
            <div class="d-flex align-items-center">
              <div class="mb-0 fw-bold text-dark fs-2">{{ facebookAccountDetail.FaceBookName }}</div>
              @if (facebookAccountDetail.IsActive) {
                <span class="badge bg-success ms-3 p-2">{{ 'socialAccount.active' | transloco }}</span>
              }
              @if (!facebookAccountDetail.IsActive) {
                <span class="badge bg-warning ms-3 p-2">{{ 'socialAccount.notActive' | transloco }}</span>
              }
            </div>
            <div class="text-muted">{{ facebookAccountDetail.FaceBookEmail }}</div>
            <div class="mt-2">
              <i class="pi pi-calendar text-primary"></i>
              <span class="text-muted ms-2">{{ 'socialAccount.connectedAt' | transloco }}</span>
              <span class="fw-semibold">{{ facebookAccountDetail.CreatedDate | date:'dd/MM/yyyy' }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  }

  <!-- Connected Facebook Pages -->
  <div class="card p-4 shadow border-0">
    <h5 class="fw-bold text-dark mb-2">{{ 'socialAccount.connectedFacebookPages' | transloco }}</h5>
    <p class="text-muted mb-3">{{ 'socialAccount.managePagesLinked' | transloco }}</p>

    <p-table [value]="facebookPages" [paginator]="false" [rows]="10" [responsiveLayout]="'scroll'"
      styleClass="p-datatable-sm">
      <ng-template pTemplate="header">
        <tr>
          <th class="py-3">{{ 'socialAccount.facebookPage' | transloco }}</th>
          <th>{{ 'socialAccount.connectedAtHeader' | transloco }}</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-page>
        <tr (click)="goToFacebookPage(page.PageLink)" class="cursor-pointer">
          <td class="d-flex align-items-center">
            <img [src]="page.PagePicture" class="rounded-circle shadow-sm" width="40" height="40"
              [alt]="'socialAccount.pageImage' | transloco" (error)="onImageError($event)">
              <span class="ms-3 fw-semibold">{{ page.PageName }}</span>
            </td>
            <td>
              <i class="pi pi-clock text-secondary"></i>
              <span class="ms-2">{{ page.CreatedDate | date:'dd/MM/yyyy HH:mm' }}</span>
            </td>
          </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="2" class="text-center text-muted">
              <i class="pi pi-info-circle me-2"></i> {{ 'socialAccount.noConnectedPages' | transloco }}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>